import { FC, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


import styles from "./styles.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { QtyInput } from "src/components";
import { useLocaitonQuery, useWishlist } from "src/hooks";
import { authSelector } from "src/store/reducers/auth";
import { isRTL, truncateWords } from "src/utils/global";
import { ProductItemType } from "src/types/products/ProductItem";
import useCartAction from "src/hooks/useCartAction";


interface ProductProp {
    product: ProductItemType
}

const Product: FC<ProductProp> = ({ product }) => {
    const navigate = useNavigate();
    const { path } = useLocaitonQuery();
    const { t } = useTranslation("products");
    const { qty, cartAddPress, cartRemovePress } = useCartAction({
        slug: product.slug,
        name: product.name,
        image: product.thumbnail,
        qty: 1,
        price: product.price,
        disc_price: product.discounted_price,
        stock: product.stock || null
    });
    const auth = useSelector(authSelector);
    const [inWishlist, setInWishlist] = useState(product.in_wishlist);
    const { wishlistAdding, wishlistRemoving } = useWishlist();

    const isDisabled = !(product.stock > 0 || product.available);

    const productDetailHandle = () => {
        navigate(`/products/${product.slug}/`)
    }

    const wishlistToggleHandle = () => {
        if (auth.access) {
            setInWishlist((oldState) => !oldState);

            if (!inWishlist) {
                wishlistAdding(product.id);
            } else {
                wishlistRemoving(product.id)
            }
        } else {
            navigate(`/auth/login/?next=${path}`);
        }
    }




    return (
        <div className={`${styles.product} ${isRTL() && styles.rtl}`}>
            <div className={styles.card}>
                <div className={styles.img__con}>
                    <img src={product.thumbnail} alt={product.name} loading="lazy" width={308} height={231} />

                    <div className={styles.img__header}>
                        <div className={`${styles.wishlist} ${inWishlist ? styles.item__active : ''}`} onClick={wishlistToggleHandle}>
                            {!inWishlist ? <FaRegHeart size={20} /> : <FaHeart size={20} />}
                        </div>
                    </div>
                    <div className={styles.overlay} onClick={productDetailHandle}>

                    </div>
                </div>
                <div className={styles.content}>
                    <h4 className={styles.title}>
                        <Link to={`/products/${product.slug}/`}>
                            {truncateWords(`${product.name}`, 6)}
                        </Link>
                    </h4>

                    {
                        product.stock > 1 ? <div className={styles.in_stock}>
                            {t("product.in_stock")}
                        </div> :
                            product.available ?
                                <div className={styles.available}>
                                    {t("product.available")}
                                </div>
                                :
                                <div className={styles.unavailable}>
                                    {t("product.unavailable")}
                                </div>
                    }
                    <p className={styles.price}>
                        {product.discounted_price && <span className={styles.discounted_price}>
                            {product.discounted_price} {t('common:lyd')}
                        </span>}
                        <span className={`${styles.original} ${product.discounted_price ? styles.org_discounted_price : ''}`}>
                            {product.price} {t('common:lyd')}
                        </span>
                    </p>
                    <div>
                        {
                            isDisabled ? <div className={styles.unavailable_btn}>
                                {t("product.unavailable")}
                            </div> :
                                (qty < 1 ?
                                    <button onClick={cartAddPress} className={`btn__primary ${styles.cart_add_btn}`}>
                                        {t('common:add_to_cart')}
                                    </button> :
                                    <div className={styles.remove__item}>
                                        <button onClick={cartRemovePress} id="variant_3" className={`btn__primary ${styles.cart_remove_btn}`}>
                                            {t('cart.remove')}
                                        </button>
                                        <div className={styles.in_Cart_qty}>
                                            <QtyInput qty={qty} itemSlug={product.slug} maxQty={product.stock > 0 ? product.stock : undefined} />
                                        </div>
                                    </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Product;
